module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/picker-ac565bd6d799c6e734dc233185be4adb.svg";